import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useNewsPageProviderContext = () => {
  const [selectedPage, setSelectedPage] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);

  const pathname = useLocation().pathname;

  useEffect(() => {
    if (!["news", "news-all"].includes(pathname.split("/")[1])) {
      setSelectedPage(0);
      setOffset(null);
    }
  }, [pathname]);

  return {
    selectedPage,
    setSelectedPage,
    setOffset,
    offset,
  };
};

const NewsPageContext = createContext(
  {} as ReturnType<typeof useNewsPageProviderContext>
);

export const NewsPageContextProvider = ({ children }) => {
  return (
    <NewsPageContext.Provider value={useNewsPageProviderContext()}>
      {children}
    </NewsPageContext.Provider>
  );
};

export const useNewsPageContext = () => useContext(NewsPageContext);
